export const columnDefs = [
  {
    field: 'candidateName',
    headerName: 'Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'jobTitle',
    headerName: 'Position',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'yearsOfExperience',
    headerName: 'Exp',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'emailId',
    headerName: 'Email',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'location',
    headerName: 'Location',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'contactNumber',
    headerName: 'Contact Number',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
  {
    field: 'earliestAvailability',
    headerName: 'Available By',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'createdDate',
    headerName: 'Received On',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'agingDays',
    headerName: 'Profile Aging',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'resume',
    headerName: 'Resume',
    filterParams: { hideMenu: true },
  },
  {
    field: 'attachments',
    headerName: 'Initial Screening Feedback',
    filterParams: { hideMenu: true },
  },
  {
    field: 'url',
    headerName: 'Links',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
  {
    field: 'status',
    headerName: 'Status',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'review',
    headerName: 'Review',
    filterParams: { hideMenu: true },
  },
  {
    field: 'history',
    headerName: 'History',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
];
